<template>
  <router-link
    v-if="item.show"
    :to="getRouterConfig(item.route)"
    :inert="item.inert"
    :active-class="
      item.active !== false ? `${itemActiveClass} router-link-active` : null
    "
    class="group gap-2 whitespace-nowrap"
    :class="{
      [`${itemActiveClass} router-link-active`]: item.active,
    }"
    @mouseup.native="!item.emitClick && pageChanged()"
    @click.native="item.emitClick && $emit('pageChanged')"
  >
    <lucide-icon
      :icon="item.icon"
      size="16"
      class="group-not-[.router-link-active]:text-primary shrink-0"
    />
    <span class="truncate">{{ $t(`routes.${item.key}`) }}</span>
  </router-link>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MenuItem',
  props: {
    itemActiveClass: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions(['LOAD_START']),

    pageChanged() {
      this.LOAD_START('navigate');
      this.$emit('pageChanged');
    },
  },
};
</script>
